import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Modal } from "../../../../common-components/modal";
import Typography from "../../../../common-components/Typography";
import Action from "../../../../common-components/Action";
import content from "../../../../constants/content";
import { font } from "../../../../constants/font";
import vmTheme from "../../../../constants/theme";
import TRACKERS from "../../../../constants/trackers";
import trackerEvents from "../../../../helper/trackerEvents";

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Header = styled.div`
  width: 100%;
  padding: 48px 40px 20px;
  border-bottom: 1px solid ${(props) => props.theme.primaryBorderColor};
  box-sizing: border-box;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 22px 48px 36px;
  box-sizing: border-box;
`;

const AvatarHighDemandModal = ({ show, onClose }) => {
  const theme = useSelector((state) => state.app.get("theme"));
  const { projectId } = useSelector((state) => state.userDetails);

  useEffect(() => {
    if (show) {
      trackerEvents(TRACKERS.AI_AVATAR_HIGH_DEMAND_VIEWED, { projectId });
    }
  }, [projectId, show]);

  const handleClose = useCallback((source) => {
    trackerEvents(TRACKERS.AI_AVATAR_HIGH_DEMAND_DISMISSED, {
      projectId,
      source,
    });
    onClose();
  }, [onClose, projectId]);

  return (
    <Modal
      showModal={show}
      onClose={() => handleClose("close")}
      width="600px"
      borderRadius="16px"
      padding="0"
      closeIconPath="vm-close-new.svg"
      closeIconWidth="24px"
      closeIconHeight="24px"
      closeIconRight="14px"
      closeIconTop="14px"
    >
      <ModalContent>
        <Header>
          <Typography
            content={content.AVATAR_HIGH_DEMAND}
            display="block"
            color="#F04F53"
            font={font.bold_20_26}
            padding="0 0 18px"
            enableTrim={false}
            align={'center'}
          />
          <Typography
            content={content.AVATAR_SCALING_TITLE}
            display="block"
            color={vmTheme[theme].panelPrimaryColor}
            font={font.boldSmall}
            enableTrim={false}
            align={'center'}
          />
        </Header>
        <Body>
          <Typography
            content={content.AVATAR_HIGH_DEMAND_DESCRIPTION}
            display="block"
            color={vmTheme[theme].secondaryColor}
            font={font.normal_16}
            enableTrim={false}
            maxWidth="500px"
            align={'center'}
          />
          <Action
            text={content.OKAY}
            onClick={() => handleClose("okay")}
            width="auto"
            height="auto"
            marginTop="32px"
            marginBottom={'0px'}
            borderRadius="10px"
            background={vmTheme[theme].secondaryBorderColor}
            hoverColor={vmTheme[theme].secondaryBorderColor}
            font={font.normal_16}
            fontColor={vmTheme[theme].polarColor}
            showHoverColor
            style={{ padding: '8px 28px' }}
          />
        </Body>
      </ModalContent>
    </Modal>
  );
};

AvatarHighDemandModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AvatarHighDemandModal;
